import React from "react";

import {
  ScheduleResourceResponse,
  isShownResource,
} from "app/utils/request/scheduling/facilityResources";
import styles from "./styles.module.scss";

type PropsDef = {
  scheduleResources?: ScheduleResourceResponse[];
};

/**
 * The bay of a session or a hold, in its popup.
 *
 * The service sends no resource while the facility has the feature off, so the
 * row does not show and the popup stays as it was.
 */
export default function ResourceRow({ scheduleResources }: PropsDef) {
  const titles = (scheduleResources ?? [])
    .filter(isShownResource)
    .map((resource) => resource.title);

  if (titles.length === 0) {
    return null;
  }

  return (
    <div className={styles.event_subtitle} data-testid="event-resource-row">
      <i className="ico ico-map-marker" />
      <span>{titles.join(", ")}</span>
    </div>
  );
}
